import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CommitProgress from "../components/CommitProgress";
import Paper from "@mui/material/Paper";
import React, { useEffect } from "react";
import ServiceOrderLinesContainer from "./ServiceOrderLinesContainer";
import ServiceOrderToolbar from "../toolbars/ServiceOrderToolbar";
import Stack from "@mui/material/Stack";
import StatusDialog from "../components/StatusDialog";
import Typography from "@mui/material/Typography";
import { useGetSalesOrderHeaderStatusD365 } from "../hooks/SalesOrder/D365/useGetSalesOrderHeaderStatusD365";
import { useGetServiceOrderInit } from "../hooks/ServiceOrder/useGetServiceOrderInit";
import { useLayoutContext } from "@ntg/component-library/contexts";
import { useParams } from "react-router-dom";

export default function ServiceOrderDetailContainer() {
    const { id } = useParams<{ id: string }>();
    const { SetPrimaryTitle, SetSecondaryHeader } = useLayoutContext();
    const serviceOrderID = Number(id);

    const { data: serviceOrderInit, isLoading } =
        useGetServiceOrderInit(serviceOrderID);

    const { data: d365Status } = useGetSalesOrderHeaderStatusD365({
        keys: {
            salesOrderNumber: serviceOrderInit?.coServiceOrderID ?? "",
            dataAreaId: serviceOrderInit?.dataAreaId ?? "",
        },
    });

    useEffect(() => {
        SetPrimaryTitle(
            isLoading
                ? "Loading..."
                : `Service Order ${serviceOrderInit?.coServiceOrderID}`,
        );

        SetSecondaryHeader(
            <ServiceOrderToolbar
                D365Status={d365Status ?? "Loading"}
                ServiceOrderID={serviceOrderID}
            />,
        );

        return () => {
            SetPrimaryTitle("");
            SetSecondaryHeader(null);
        };
    }, [SetPrimaryTitle, isLoading, serviceOrderInit, serviceOrderID, d365Status]);

    return (
        <Stack spacing={2}>
            <Card component={Paper} sx={{ padding: 1 }}>
                <CardContent
                    sx={{
                        display: "flex",
                        alignContent: "center",
                        gap: 2,
                        flexDirection: "column",
                    }}
                >
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        gap={6}
                    >
                        <Typography variant="h5">
                            Contact: {serviceOrderInit?.contact}
                        </Typography>
                        <Typography variant="h5">
                            Boat: {serviceOrderInit?.boat}
                        </Typography>
                        <Typography variant="h5">
                            D365 Company: {serviceOrderInit?.dataAreaId}
                        </Typography>
                    </Stack>

                    <ServiceOrderLinesContainer
                        serviceOrderID={serviceOrderID}
                    />
                </CardContent>
            </Card>

            <StatusDialog title="Commit Progress" expectedPaths={["commit"]}>
                <CommitProgress />
            </StatusDialog>
        </Stack>
    );
}
